import { useQuery } from "@tanstack/react-query";
import { USER_URL } from "../util/constants";
import useApi from "./useApi";
import User from "../interfaces/user";

const useUser = (username: any) => {
    const { recover } = useApi<User>(`${USER_URL}/${username}`);

    return useQuery({
        queryKey: ["user", username],
        queryFn: () => recover()
    });
};

export default useUser;